import { TaskDefinitionDto } from '@/api/generated';

export type TaskDefinitionTranslation = Record<'UNKNOWN' | TaskDefinitionDto, string>;

export const taskDefinitionTranslation: TaskDefinitionTranslation = {
  [TaskDefinitionDto.Custom]: 'Zadanie własne',
  [TaskDefinitionDto.ProcessCustomerUpdate]: 'Uzupełnij klienta',
  [TaskDefinitionDto.ProcessEventConfirmation]: 'Potwierdź wydarzenie',
  [TaskDefinitionDto.ProcessFirstContact]: 'Pierwszy kontakt',
  [TaskDefinitionDto.ProcessNameUpdate]: 'Uzupełnij nazwę procesu',
  [TaskDefinitionDto.ProcessOfferOfferingPeriodEnd]: 'Kończy się termin oferowania',
  [TaskDefinitionDto.ProcessOnNewEmail]: 'Nowy mail',
  [TaskDefinitionDto.ProcessOnNewProcess]: 'Nowy proces',
  [TaskDefinitionDto.ProcessOwnerUpdate]: 'Zmiana opiekuna',
  UNKNOWN: 'Zadanie',
};
